import { render, staticRenderFns } from "./Date.vue?vue&type=template&id=4f520e43&scoped=true&"
import script from "./Date.vue?vue&type=script&lang=js&"
export * from "./Date.vue?vue&type=script&lang=js&"
import style0 from "./Date.vue?vue&type=style&index=0&id=4f520e43&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f520e43",
  null
  
)

export default component.exports